/**
 * 全局环境变量
 */

const { vueAppName, apiUrl, socketUrl, staticHost } = constructEnv(process.env.VITE_API_ENV)
const windowWH = { windowW: null, windowH: null } // 全局的窗口高度和宽度
const Config = {
  runEnv: 'web', // 运行环境: app, web, mp-weixin, mp-alipay, mp-baidu, mp-toutiao
  vueAppName,
  apiUrl,
  staticHost,
  socketUrl,
  windowWH,
  // 显示更新提示
  showUpdateTip: true,
  defaultImg: {
    iconCry: '',
    assets: {
      // 新增资源后记得同步到/assets/css/variables.scss
    }
  },
  loadingInstance: {},
  footerInfo: {
    website: '杭州话饼智能科技有限公司',
    company: '杭州话饼智能科技有限公司',
    tel: '0730-xxx',
    workTime: '08:30 —— 17:30',
    address: 'xxx',
    copyRight: 'Copyright ©杭州话饼智能科技有限公司 | ',
    beian: '浙ICP备xxx号',
    beianHref: 'https://beian.miit.gov.cn/#/Integrated/index'
  },
  loginPath: '/login',
  authPageUrl: '/login',
  signRoute: [], // 用于标记的路由数组
  uploadActionUrl: 'https://huabing-uniapp.oss-cn-hangzhou.aliyuncs.com',
  aloneInventoryOnSaleTemplate: 'https://huabing-admin.oss-cn-hangzhou.aliyuncs.com/goods-manage/alone_inventory_on_sale_template.xlsx',
  shareInventoryOnSaleTemplate: 'https://huabing-admin.oss-cn-hangzhou.aliyuncs.com/goods-manage/share_inventory_on_sale_template.xlsx',
  batchShelvesTemplate: 'https://huabing-admin.oss-cn-hangzhou.aliyuncs.com/goods-manage/batch_shelves_template.xlsx',
  salePlanShopGoodsTemplate: 'https://huabing-admin.oss-cn-hangzhou.aliyuncs.com/goods-manage/sale_plan_shop_goods_template.xlsx'
}

/**
 * 构造环境配置
 * @param {string} env 环境type
 * @returns 环境对象
 */
function constructEnv (env) {
  let vueAppName = ''
  let apiUrl = ''
  let socketUrl = ''
  let staticHost = ''
  switch (env) {
    case 'development':
      vueAppName = '开发环境'
      apiUrl = 'http://192.168.201.117:7234'
      socketUrl = ''
      staticHost = 'http://192.168.201.117:7234'
      break
    case 'test':
      vueAppName = '测试环境'
      apiUrl = 'http://192.168.2.253:9900'
      socketUrl = ''
      staticHost = ' http://192.168.2.253:8080'
      break
    case 'inner':
      vueAppName = 'huaBingInner环境'
      apiUrl = 'https://huabinginner.huabing.online'
      socketUrl = ''
      staticHost = 'https://huabinginner.huabing.online'
      break
    case 'preProd':
      vueAppName = '预发布环境'
      apiUrl = 'https://kuaie02.huabing.online'
      socketUrl = ''
      staticHost = 'https://kuaie02.huabing.online'
      break
    case 'production':
      vueAppName = '生产环境'
      apiUrl = 'https://kuaie01.huabing.online'
      socketUrl = ''
      staticHost = 'https://kuaie01.huabing.online'
      break
    default:
      vueAppName = '开发环境'
      apiUrl = 'http://192.168.2.251:9900'
      socketUrl = ''
      staticHost = 'http://192.168.2.251:8080'
      break
  }
  return { vueAppName, apiUrl, socketUrl, staticHost }
}

module.exports = {
  constructEnv,
  Config
}

